import { render, staticRenderFns } from "./PropertyGeneralForm.vue?vue&type=template&id=465f04bb&scoped=true&"
import script from "./PropertyGeneralForm.vue?vue&type=script&lang=js&"
export * from "./PropertyGeneralForm.vue?vue&type=script&lang=js&"
import style0 from "./PropertyGeneralForm.vue?vue&type=style&index=0&id=465f04bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465f04bb",
  null
  
)

export default component.exports